import { FC, PropsWithChildren } from "react";
import { Box, Toolbar } from "@mui/material";
import { darkSurfaces } from "../../theme";

export const MenuBar: FC<PropsWithChildren> = ({ children }) => {
  return (
    <Box>
      <Toolbar
        className="ma-menubar"
        variant="dense"
        disableGutters={true}
        sx={{
          zIndex: 1,
          minHeight: 56,
          padding: "8px",
          display: "flex",
          backgroundColor: (theme) =>
            theme.palette.mode === "dark"
              ? darkSurfaces.header
              : theme.palette.background.default,
          boxShadow: (theme) =>
            theme.palette.mode === "dark"
              ? "0 6px 16px -10px rgba(0, 0, 0, 0.9)"
              : "0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12)",
          borderBottom: (theme) =>
            theme.palette.mode === "dark"
              ? `1px solid ${darkSurfaces.border}`
              : "none"
        }}
      >
        {children}
      </Toolbar>
    </Box>
  );
};
